<template>
    <div>
        <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
            <div style="display: flex; align-items: center; flex-grow: 1;">
                <router-view></router-view>
                <el-button size="small" type="success" v-if="['ADMIN', 'MANAGER'].includes(role)" icon="el-icon-plus"
                    @click="openAddEditDialog({}, 'add')">添加</el-button>
            </div>
            <export-components :apiFunction="exportDeductionRecords"
                :requestData="getSearch({ })" :option="option"
                @sendData=getSearchData>
            </export-components>
        </div>
        <w-table :columns="columns" :table-data="tableData" ref="wMyTable"
            @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
            @pageChange="handlePagePagination">
            <template slot="operation" slot-scope="{text,record,index}">
                <el-button size="mini" type="warning" v-if="['ADMIN', 'MANAGER'].includes(role)" icon="el-icon-edit"
                    @click="openAddEditDialog(record, 'edit')">编辑</el-button>
                <!-- <el-button size="mini" type="warning"  icon="el-icon-view"
                    @click="openAddEditDialog(record, 'view')">查看</el-button> -->
            </template>
            <template slot="deductionType" slot-scope="{text,record,index}">
                <span v-if="text">{{ deductionType[text]?.name || text }}</span>
                <span v-else style="color: #5daf34">NA</span>
            </template>
            <template slot="filterType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;width:250px">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='提现'>提现</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='代付款'>代付款</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='买办公用品'>买办公用品</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='横向项目'>横向项目</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='其他'>其他</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <add-edit-deduction-records :show-dialog="showAddEditDialog" v-if="showAddEditDialog"
            :select-detail="selectDetail" :select-type="selectType"
            @submit="closeAddEditDialog"></add-edit-deduction-records>
    </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import { tableOperationMixin } from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import { deductionRecords } from "@/utils/data/tableCol/deduction_records/deductionRecords";
import { getDeductionRecordsPage, exportDeductionRecords} from "@/api/dilivery/deduction_records";
import AddEditDeductionRecords from "@/components/deduction_records/AddEditDeductionRecords.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import ExportComponents from "@/components/ExportComponents.vue";

export default {
    name: "DeductionRecords",
    components: { PictureLoading, TableHeadNote, AddEditDeductionRecords, ExportComponents },
    mixins: [tableOperationMixin],
    data() {
        return {
            role: getDataInLocalStorage('role'),
            showAddEditDialog:false,
            selectDetail:{},
            selectType:'',
            searchConditionTag: [],//搜索tag
            sortConditionTag: [],
            tableData: [],
            page: {
                pageSize: 10,
                currentNum: 1,
                total: null
            },
            option: [
                { label: '创建时间', value: 'createTime' },
            ],
            loading: true,
            deductionType: {
                WITHDRAWAL: {
                    name: '提现',
                },
                AGENT_PAYMENT: {
                    name: '代付款',
                },
                OFFICE_SUPPLIES: {
                    name: '买办公用品',
                },
                HORIZONTAL_PROJECT: {
                    name: '横向项目',
                },
                OTHER: {
                    name: '其他',
                },
            }
        }
    },
    computed: {
        columns() {
            return JSON.parse(JSON.stringify(deductionRecords(this.searchConditionTag || {})))
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        exportDeductionRecords,
        getSearchData(sendData) {
            if (sendData) {
                this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
                if (Object.keys(sendData).length) {
                    this.searchConditionTag.push(sendData)
                }
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
                this.getData('search')
            }
        },
        openAddEditDialog(row, type) {
            if (row) {
                this.selectDetail = { ...row }
            } else {
                this.selectDetail = {}
            }
            this.selectType = type
            this.showAddEditDialog = true
        },
        closeAddEditDialog(type) {
            this.showAddEditDialog = false
            this.selectDetail = {}
            this.selectType = ''
            if (type === 'confirm') {
                this.getData()
            }
        },
        getTableSearchSortCon(searchConditionTag, sortConditionTag) {
            this.searchConditionTag = searchConditionTag
            this.sortConditionTag = sortConditionTag
            this.getData('search')
        },
        // 获取数据
        getData(type) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            }
            if (type) {
                this.sortConditionTag.forEach(item => {
                    params["order"] = item.colName + "." + item.order
                })
                params['page.current'] = 1
                params['page.size'] = 10
            }
            let sendData = {}
            sendData = this.getSearch(sendData)
            getDeductionRecordsPage(params, sendData).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records
                    this.page.currentNum = parseInt(res.data.current)
                    this.page.pageSize = parseInt(res.data.size)
                    this.page.total = parseInt(res.data.total)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getSearch(sendData) {
            this.searchConditionTag.forEach(item => {
                let value = item.value
                if (item.key === 'deductionType') {
                    if (item.value === '提现') {
                        value = 'WITHDRAWAL'
                    } else if (item.value === '代付款') {
                        value = 'AGENT_PAYMENT'
                    } else if (item.value === '买办公用品') {
                        value = 'OFFICE_SUPPLIES'
                    } else if (item.value === '横向项目') {
                        value = 'HORIZONTAL_PROJECT'
                    } else if (item.value === '其他') {
                        value = 'OTHER'
                    }
                }
                if (['salesName','customerContactsName'].includes(item.key)) {
                    sendData[item.key] = value
                } else if (this.option.map(it => it.value).includes(item.key)) {
                    sendData["query#" + item.key + ".BETWEEN"] = item.value
                } else {
                    sendData["query#" + item.key + '.LIKE'] = value
                }
            })
            return sendData
        },
        //页码的变动
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        }
    }
}
</script>

<style scoped></style>
